export default __webpack_public_path__ + "static/media/sabemi-preto.0114cddf.png";